/**
 * @owner @Appboy/whats-app
 * WhatsApp Commerce Data Schema
 *
 * Shared schema for commerce/catalog data used in WhatsApp messages.
 * Used in both template messages (catalog templates) and response messages (product layouts).
 */

import { z } from "zod";

// Same between GET and POST
export const whatsAppCommerceDataSchema = z
  .object({
    thumbnail_product_retailer_id: z.string().nullable().optional(),
    product_sections: z
      .array(
        z.object({
          products: z.array(
            z.object({
              product_retailer_id: z.string().nullable().optional(),
              catalog_id: z.string().nullable().optional(),
            })
          ),
          title: z.string().nullable().optional(),
        })
      )
      .optional(),
  })
  .optional()
  .nullable();
